import { render } from "./CtaSection.vue?vue&type=template&id=ef4fb03e&scoped=true"
const script = {}

import "./CtaSection.vue?vue&type=style&index=0&id=ef4fb03e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef4fb03e"]])

export default __exports__